{
  "R": [0, 0, 127, 255, 127],
  "G": [0, 127, 255, 127, 0],
  "B": [127, 255, 127, 0, 0],
  "A": [0, 32, 64, 96, 128],
  "I": [0, 63, 128, 192, 255]
}
